/**
 * The raised surface every box in a signal-flow diagram sits on.
 *
 * One primitive rather than three near-identical ones: the stage cards, the
 * per-stack cards and the output cards differ only in what they contain.
 */

import type { ReactNode } from 'react';
import { Box, useTheme, type SxProps, type Theme } from '@mui/material';

import { flowToken, type FlowToken } from './tokens';

interface FlowTileProps {
  children: ReactNode;
  /** Border token, so a lane can be outlined by its own state. */
  borderToken?: FlowToken;
  sx?: SxProps<Theme>;
}

export default function FlowTile({
  children,
  borderToken = 'wash700',
  sx,
}: FlowTileProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        backgroundColor: flowToken(theme, 'wash850'),
        border: `1px solid ${flowToken(theme, borderToken)}`,
        borderRadius: 1,
        px: 1.75,
        py: 1.25,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
